var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('document-table', {
    attrs: {
      "filters": _vm.documentFleetFilter,
      "refs": _vm.documentFleetRefs,
      "module": _vm.reportFleetSignDocumentModule,
      "additionalControlElements": _vm.additionalControlElements,
      "hideCreate": true
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "hideLeft": false,
      "hideRight": false,
      "title": _vm.$t('report.fleet.documentSharingDialog.title'),
      "subtitle": _vm.dialogSubtitle,
      "leftText": _vm.dialogLeftText,
      "rightText": _vm.dialogRightText,
      "rightDisabled": _vm.isDialogLoading || !_vm.canConfirm,
      "rightLoading": _vm.isDialogLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.onLeftClick,
      "rightClick": _vm.onRightClick,
      "close": _vm.closeShareDialog
    }
  }, [_c('v-window', {
    staticClass: "mt-2",
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.StepWindow.PICK
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm.unsharedSharings.length ? _c('v-subheader', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('report.fleet.documentSharingDialog.unshared'))
    }
  }) : _vm._e(), _vm._l(_vm.unsharedSharings, function (sharedContent) {
    return [_c('refs-shared-content', {
      key: 'unshared-' + sharedContent.id,
      attrs: {
        "item": sharedContent
      },
      on: {
        "click": function click($event) {
          return _vm.selectSharing(sharedContent);
        },
        "openDetail": _vm.setOpenedSharedDocument
      }
    })];
  }), _vm.sharedSharings.length ? _c('v-subheader', {
    staticClass: "mt-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('report.fleet.documentSharingDialog.shared'))
    }
  }) : _vm._e(), _vm._l(_vm.sharedSharings, function (sharedContent) {
    return [_c('refs-shared-content', {
      key: 'shared-' + sharedContent.id,
      attrs: {
        "item": sharedContent
      },
      on: {
        "click": function click($event) {
          return _vm.selectSharing(sharedContent);
        },
        "openDetail": _vm.setOpenedSharedDocument
      }
    })];
  })], 2), _vm.openedSharedDocument ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.openedSharedDocument
    },
    on: {
      "close": function close($event) {
        _vm.openedSharedDocument = null;
      }
    }
  }) : _vm._e()], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.StepWindow.CONFIRM
    }
  }, [_vm.selectedSharing ? _c('div', {
    staticClass: "pa-2"
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('refs-shared-content', {
    attrs: {
      "item": _vm.selectedSharing
    },
    on: {
      "openDetail": _vm.setOpenedSharedDocument
    }
  })], 1), _vm.openedSharedDocument ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.openedSharedDocument
    },
    on: {
      "close": function close($event) {
        _vm.openedSharedDocument = null;
      }
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }